import { TEST, POST_SURVEY_DETAIL_BY_ID, FETCH_SURVEY_DETAIL_BY_ID, FETCH_LANGUAGE_LIST } from "./details-store-constants";

const initialState = {
    test: "test123",
    getSurveyByID: {}
};

const DetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload.test
            };
        case FETCH_SURVEY_DETAIL_BY_ID:
            return {
                ...state,
                getSurveyByID: action.payload.getSurveyByID
            };
        case FETCH_LANGUAGE_LIST:
            return {
                ...state,
                getLanguageList: action.payload.getLanguageList
            };
        default:
            return state;
    }
};


export default DetailsReducer;
